import React, { useEffect, useState, useRef } from "react"
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'

import ReactSelect from 'pages/parts/ReactSelect'
import QuickElementModal from 'pages/main/elements/QuickElementModal'
import { httpOk, GET, PUT } from "helpers/api"
import { formatMoney, formatDate, findKeyFromArrayByValue } from 'helpers/helpers'

function Preview() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const reduxAccount = useSelector(state => state.account)

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const [data, setData] = useState({})
	const [wms, setWms] = useState([])
	const [suppliers, setSuppliers] = useState([])
	const [elements, setElements] = useState([])
	const [elementsDuplicate, setElementsDuplicate] = useState([])
	const [modalConfirm, setModalConfirm] = useState(false)
	const [modalElement, setModalElement] = useState(false)
	const [quickElementRowIndex, setQuickElementRowIndex] = useState(null)
	const [quickElementName, setQuickElementName] = useState('')

	async function update(stage = 1) {
		if (stage === 1) {
			setModalConfirm(true)
			return
		}

		const response = await PUT('/service/documents-in', data, { loader: true })
		if (httpOk(response)) {
			navigate('/service/idocuments-in')
			return
		}

		// Отправитель мог поправить документ, пока страница была открыта: перечитываем
		// его, чтобы человек принял то, что отправитель прислал на самом деле
		setModalConfirm(false)
		getData()
	}

	// REACTSELECT LOGIC
	function handleSelectSearch(value) {
		if (!value) {
			setElements([...elementsDuplicate])
			return
		}
		var elementsDuplicateCopy = [...elementsDuplicate]

		var filteredItems = elementsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setElements(filteredItems)
	}

	// Связь хранится по товару отправителя, а не по строке: отправитель взвешивает
	// каждую коробку отдельной строкой, и все строки одного товара получают один продукт.
	// Иначе «+» на каждой строке заводит по новой карточке на коробку
	function handleSelectElement(option, index) {
		var dataCopy = { ...data }
		var fromProductId = dataCopy.items[index]['product_id']
		for (let i = 0; i < dataCopy.items.length; i++) {
			if (i !== index && dataCopy.items[i]['product_id'] !== fromProductId) continue
			dataCopy.items[i]['element_id'] = option.product_id
			dataCopy.items[i]['unit_id'] = undefined
			dataCopy.items[i]['packaging_id'] = undefined
			dataCopy.items[i]['unit_name'] = option.unit_name
			dataCopy.items[i]['unit_quantity'] = option.unit_quantity
			dataCopy.items[i]['units'] = option.units
		}
		setData(dataCopy)
	}

	function closeReactSelect() {
		setTimeout(() => {
			var elementsCopy = [...elements]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i]['selected'] = false
			}
			if (elementsCopy[0] && elementsCopy[0]['selected'])
				elementsCopy[0]['selected'] = true
			setElements(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = elements.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...elements]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[elements.length - 1].selected = true
						currentIndex = elements.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === elements.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setElements(elementsCopy)
		}
	}

	function handleSelectItemUnit(option, index) {
		var dataCopy = { ...data }

		dataCopy.items[index]['unit_id'] = option.id
		dataCopy.items[index]['packaging_id'] = option.id
		dataCopy.items[index]['unit_name'] = option.name
		dataCopy.items[index]['unit_quantity'] = option.quantity

		setData(dataCopy)
	}
	// REACTSELECT LOGIC

	// NEW ELEMENT LOGIC
	// Открыть модалку создания продукта: если открыли из строки — подставляем её внешнее название
	function toggleModalElement(bool, rowIndex = null) {
		setQuickElementRowIndex(rowIndex)
		setQuickElementName(rowIndex !== null ? (data?.items?.[rowIndex]?.item_name ?? '') : '')
		setModalElement(bool)
	}

	// Созданный продукт добавляем в справочник и сразу привязываем к строке
	function handleCreatedElement(element) {
		if (!element) return

		const createdElement = {
			...element,
			product_id: element.product_id ?? element.id,
			unit_quantity: 1,
			// базовая единица — без id, как её отдаёт список: id тут ждут из products_units (packaging_id)
			units: element.units ?? [{
				name: element.unit_name,
				quantity: 1,
			}],
		}
		const elementsDuplicateCopy = [...elementsDuplicate, createdElement]
		setElements(elementsDuplicateCopy)
		setElementsDuplicate(elementsDuplicateCopy)

		if (quickElementRowIndex !== null && data?.items?.[quickElementRowIndex]) {
			handleSelectElement(createdElement, quickElementRowIndex)
		}
	}
	// NEW ELEMENT LOGIC

	// АВТОПОДБОР: связать внешние названия с продуктами из своего справочника
	function normalizeName(str) {
		return (str || '').toString().toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim()
	}

	// Расстояние Левенштейна между двумя строками
	function levenshtein(a, b) {
		if (a === b) return 0
		if (!a.length) return b.length
		if (!b.length) return a.length
		var prev = Array(b.length + 1).fill(0).map((_, i) => i)
		for (let i = 0; i < a.length; i++) {
			var curr = [i + 1]
			for (let j = 0; j < b.length; j++) {
				var cost = a[i] === b[j] ? 0 : 1
				curr[j + 1] = Math.min(curr[j] + 1, prev[j + 1] + 1, prev[j] + cost)
			}
			prev = curr
		}
		return prev[b.length]
	}

	// Найти самый подходящий продукт: точное совпадение → вхождение → похожесть (порог 0.5)
	function findBestElement(externalName) {
		var target = normalizeName(externalName)
		if (!target) return null
		var best = null
		var bestScore = 0
		for (let i = 0; i < elementsDuplicate.length; i++) {
			var name = normalizeName(elementsDuplicate[i].name)
			if (!name) continue
			if (name === target) return elementsDuplicate[i]
			var maxLen = Math.max(target.length, name.length)
			var score = maxLen ? 1 - levenshtein(target, name) / maxLen : 0
			if (name.includes(target) || target.includes(name)) score = Math.max(score, 0.9)
			if (score > bestScore) {
				bestScore = score
				best = elementsDuplicate[i]
			}
		}
		return bestScore >= 0.5 ? best : null
	}

	// Подобрать продукт только для строк без связи (element_id пуст); связанные не трогаем
	function autoMatchElements() {
		if (!data.items) return
		var dataCopy = { ...data }
		for (let i = 0; i < dataCopy.items.length; i++) {
			if (dataCopy.items[i].element_id) continue
			var best = findBestElement(dataCopy.items[i].item_name)
			if (best) {
				dataCopy.items[i]['element_id'] = best.product_id
				dataCopy.items[i]['unit_name'] = best.unit_name
				dataCopy.items[i]['unit_quantity'] = best.unit_quantity
				dataCopy.items[i]['units'] = best.units
			}
		}
		setData(dataCopy)
	}

	// Склады и поставщики — точки самого документа, а не той, что выбрана в шапке:
	// у владельца несколько точек, и шапка (общая на все вкладки через localStorage)
	// после F5 могла оказаться другой — тогда кнопка «Принять» пропадала, а склад
	// по умолчанию предлагался чужой точки
	async function getData() {
		var response = await GET(`/service/documents-in/${id}`, {}, { loader: true })
		if (httpOk(response)) {
			if (!response.data.wms_id && Number(reduxAccount.pos_id) === Number(response.data.pos_id)) {
				response.data.wms_id = reduxAccount.wms_id
			}
			setData(response.data)
			getWms(response.data.pos_id)
		}
	}

	async function getWms(posId) {
		const responseSuppliers = await GET('/documents-in-suppliers', { pos_id: posId }, { loader: true })
		if (httpOk(responseSuppliers)) setSuppliers(responseSuppliers.data)

		const response = await GET(`/helper/wms?pos_id=${posId}`, {}, { loader: true })
		if (httpOk(response)) setWms(response.data)
	}

	async function getElements() {
		const response = await GET(`/service/documents-in-elements`, {}, { loader: true })
		if (httpOk(response)) {
			setElements(response.data)
			setElementsDuplicate(response.data)
		}
	}

	useEffect(() => {
		getData()
		getElements()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('receipt_from_supplier')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('preview')}</h6>
					</div>
				</div>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<h4 className="fw-600">{t('document_from')} {formatDate(data.created_at, 'dd.MM.yy HH:mm')}</h4>
					<div className="flex-column preview-info">
						<div className="d-flex gap-2">
							<div className="fw-600">{t('pos')}:</div>
							<div>{data.pos_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('supplier')}:</div>
							<div>
								{data.supplier_name || (data.supplier_id
									? suppliers.find(option => option.id === data.supplier_id)?.name
									: '—')}
							</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('wms')}:</div>
							<div>{data.wms_name || '—'}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('note')}:</div>
							<div>{data.note}</div>
						</div>
					</div>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '50%' }}>{t('external_name')}</th>
									<th style={{ 'width': '50%' }}>
										<div className="d-flex justify-content-between align-items-center gap-2">
											<span>{t('product')}</span>
											<div className="d-flex align-items-center gap-1">
												<button type="button" className="btn btn-sm btn-outline-primary py-0 px-1"
													title={t('auto_match')}
													onClick={() => autoMatchElements()}>
													<i className="uil uil-link"></i>
												</button>
												<div className="table-action-button table-action-primary-button"
													title={t('create_element')}
													onClick={() => toggleModalElement(true)}>
													<i className="uil-plus"></i>
												</div>
											</div>
										</div>
									</th>
									<th style={{ 'minWidth': '70px' }} className="text-start">{t('unit')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-start">{t('unit')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-end">{t('price')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.items?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.item_name}</td>
										<td>
											<div className="d-flex align-items-center gap-1">
												<div className="w-100">
													<ReactSelect
														search={handleSelectSearch}
														value={findKeyFromArrayByValue(elementsDuplicate, 'id', item.element_id, 'name')}
														index={index}
														scrollRef={scrollRef}
														options={elements}
														onClose={() => closeReactSelect()}
														selectItem={(option) => handleSelectElement(option, index)}
														onKeyUp={(e) => {
															if (e.keyCode === 40 || e.keyCode === 38) {
																handleTableKeyDown(e)
															}
														}}
														table={
															<table className="table mb-0">
																<tbody ref={tbodyRef}>
																	{elements.map((selectItem, selectIndex) => (
																		<tr
																			id={selectItem.id}
																			className={`cursor ${((selectItem.selected || selectItem.id === item.element_id) && 'selected')}`}
																			tabIndex={-1}
																			key={selectIndex}
																			onClick={() => handleSelectElement(selectItem, index)}
																			onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																			<td>{selectItem.name}</td>
																			<td className="text-end">{selectItem.product_type_name}</td>
																		</tr>
																	))}
																</tbody>
															</table>
														}
													/>
												</div>
												<div className="table-action-button table-action-primary-button"
													title={t('create_element')}
													onClick={() => toggleModalElement(true, index)}>
													<i className="uil-plus"></i>
												</div>
											</div>
										</td>
										<td>
											<ReactSelect
												tabIndex={-1}
												uniqueId="select2"
												search={handleSelectSearch}
												value={item.unit_name}
												index={index}
												scrollRef={scrollRef}
												options={item.units}
												onClose={() => closeReactSelect()}
												selectItem={(option) => handleSelectItemUnit(option, index)}
												onKeyUp={(e) => {
													if (e.keyCode === 40 || e.keyCode === 38) {
														handleTableKeyDown(e)
													}
												}}
												table={
													<table className="table mb-0">
														<tbody ref={tbodyRef}>
															{item?.units?.map((selectItem, selectIndex) => (
																<tr
																	id={selectItem.id}
																	className={`cursor ${((selectItem.selected || selectItem.id === item.unit_id) && 'selected')}`}
																	tabIndex={-1}
																	key={selectIndex}
																	onClick={() => handleSelectItemUnit(selectItem, index)}
																	onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																	<td>{selectItem.name}</td>
																</tr>
															))}
														</tbody>
													</table>
												}
											/>
										</td>
										<td className="text-end">{formatMoney(item.quantity, 2)}</td>
										<td className="text-start">{item.external_unit_name}</td>
										<td className="text-end">{formatMoney(item.sale_price, 2)}</td>
										<td className="text-end">{formatMoney(item.sale_price * item.quantity, 2)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(data?.overall?.overall_quantity, 2)}</b>
									</td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(data?.overall?.overall_amount, 2)}</b>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div className="btn-wrapper gap-2">
						<button type="button" className="btn btn-warning btn-rounded btn-wide"
							onClick={() => navigate(-1)}>
							{t('back')}
						</button>

						{data.status === -2 &&
							<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
								onClick={() => update(1)}>
								{t('accept')}
							</button>
						}
					</div>
				</div>
			</div>

			<QuickElementModal
				show={modalElement}
				defaultName={quickElementName}
				defaultValues={{ wms_id: data.wms_id }}
				onClose={() => toggleModalElement(false)}
				onCreated={handleCreatedElement}>
			</QuickElementModal>

			{/* MODAL CONFIRM */}
			<Modal show={modalConfirm} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => setModalConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('confirm')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{!data.supplier_id &&
						<div className="form-group">
							<label>{t('supplier')}<span className="required-mark">*</span></label>
							{data.supplier_name &&
								<div className="text-muted mb-2">
									{t('external_name')}: {data.supplier_name}
								</div>
							}
							<Select
								options={suppliers}
								value={suppliers.find(option => option.id === data.supplier_id) || null}
								onChange={(option) => setData({
									...data,
									supplier_id: option.id,
									supplier_name: option.name,
								})}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
					}
					<div className="form-group">
						<label>{t('wms')}<span className="required-mark">*</span></label>
						<Select
							options={wms}
							value={wms.find(option => option.id === data.wms_id)}
							onChange={(option) => setData({ ...data, 'wms_id': option.id })}
							placeholder=""
							noOptionsMessage={() => t('list_empty')}
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
						/>
					</div>
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalConfirm(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							disabled={!data.wms_id || !data.supplier_id}
							onClick={() => update(3)}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL CONFIRM */}
		</>
	)
}

export default Preview